/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    global: {
        ':root': {
            '--chakra-shadows-outline': '0 0 0 2px var(--chakra-colors-webTheme-focus)'
        },
        '*': {
            WebkitTapHighlightColor: 'transparent'
        },
        'html, body': {
            backgroundColor: 'white',
            color: 'black'
        },
        body: {
            minHeight: '100vh'
        },
        // Prevent horizontal layout shift when a Drawer/Modal locks body scroll.
        //   - Neutralize react-remove-scroll-bar's `margin-right` injection (which
        //     would squeeze body width and can cause reflow).
        //   - Compensate for the hidden scrollbar using `padding-right` set to the
        //     library's own `--removed-body-scroll-bar-size` variable. This is the
        //     *actual measured* scrollbar width at the moment the drawer opens, so
        //     it self-adjusts perfectly across scrollbar modes:
        //       * Classic scrollbars (Windows, macOS+mouse): exact pixel-match, no shift.
        //       * Overlay scrollbars (macOS without mouse): measured width = 0 → no
        //         extra space → no shift.
        //   - Applied on body (not html) so `position: fixed` drawers still extend to
        //     the viewport's right edge (html-level gutter would block that — see
        //     https://issues.chromium.org/issues/40792788).
        // Higher specificity (html body[...]) beats the library's body[...] !important rule.
        'html body[data-scroll-locked]': {
            marginRight: '0 !important',
            paddingRight: 'var(--removed-body-scroll-bar-size, 0) !important'
        },
        '.react-target': {
            display: 'flex',
            minHeight: '100vh',
            /* Keep horizontal bleed from CMS sections/carousels from creating
             * page-level horizontal scroll, without putting overflow rules on
             * html/body. Body-level overflow clipping interferes with modal
             * portals and react-remove-scroll's body lock bookkeeping. */
            overflowX: 'clip'
        },
        '*[role="button"]': {
            _focusVisible: {
                outline: 0,
                boxShadow: 'var(--chakra-shadows-outline)'
            }
        },
        '.js-only': {
            display: 'none'
        },
        '.js-enabled .js-only': {
            display: 'block'
        },
        '.js-enabled .no-js-only': {
            display: 'none'
        },
        // Force first accordion panel open in SSR (before js-enabled is added).
        // After hydration, framer-motion takes over via inline styles.
        'html:not(.js-enabled) .pdp-accordion > .chakra-accordion__item:first-of-type .chakra-collapse':
            {
                height: 'auto !important',
                opacity: '1 !important',
                overflow: 'visible !important',
                display: 'block !important'
            }
    }
}
